import {useQuery, useQueryClient} from '@tanstack/react-query'
import {getStoreRouteCacheTime} from "../utils/helpers";
import Constants from "../config/constants";

const uniqId = 1;

export function useCliff(url, slug, user = {}, forceStaleTime = null) {
    const queryClient = useQueryClient();
    let options = {...queryClient.getDefaultOptions().queries, staleTime: 0};
    let cacheTime = null;

    if (user?.customerRoutes) {
        const storeRoutes = Array.isArray(user.customerRoutes) ? user.customerRoutes : [];
        const storeRoute = storeRoutes.find((route) => {
            if (route.type === Constants.CLIFF && route.route?.cliff?.slug === slug) {
                return route;
            }
        });

        cacheTime = getStoreRouteCacheTime(storeRoute?.endValidationDate);
        if (storeRoute && cacheTime > 0) {
            options.refetchOnWindowFocus = false;
            options.cacheTime = cacheTime;
            options.staleTime = cacheTime;
            options.networkMode ='offlineFirst';
        } else {
            options.staleTime = 0;
        }
    }

    if (forceStaleTime !== null) {
        options.staleTime = forceStaleTime;
    }

    //options.enabled = Boolean(url && slug && user?.email /*&& cacheTime !== -1*/);
    options.queryKey = [url, slug, uniqId];

    return useQuery(options);
}